import { PlusIcon } from '@interstate/components/Icons';
import { Action } from '@interstate/components/Action';
import { CustomerFieldsAccordionContainer, ExpandedSectionCard } from './HousingAndEmploymentInfo.style';
import { CustomerFieldsLayoutHeader } from './CustomerFieldsLayoutHeader';
import { useCustomerCardContext } from '../CustomerCardProvider';
import { EmploymentFields } from './EmploymentFields';

export const PreviousEmployment = () => {
    const {
        isPrevEmploymentFieldsExpanded,
        setIsPrevEmploymentFieldsExpanded,
        isLocked,
        handleInputChange,
        handleNumberInputChange
    } = useCustomerCardContext();

    const handleDelete = () => {
        handleInputChange('previousEmployment.status', '');
        handleInputChange('previousEmployment.employerName', '');
        handleInputChange('previousEmployment.occupation', '');
        handleInputChange('previousEmployment.workPhone', '');
        handleNumberInputChange('previousEmployment.totalYearsEmployed', '');
        handleNumberInputChange('previousEmployment.totalMonthsEmployed', '');
        setIsPrevEmploymentFieldsExpanded(false);
    };

    return (
        <CustomerFieldsAccordionContainer data-testid="previous-employment-section">
            {!isPrevEmploymentFieldsExpanded ? (
                <Action
                    data-testid="previous-employment-button"
                    actionIcon={{ icon: <PlusIcon />, start: true }}
                    onClick={() => setIsPrevEmploymentFieldsExpanded(true)}
                >
                    Add Previous Employment Information
                </Action>
            ) : (
                <ExpandedSectionCard>
                    <CustomerFieldsLayoutHeader
                        onDelete={handleDelete}
                        deleteTestId="previous-employment-delete-button"
                        disabled={isLocked}
                    >
                        Previous Employment Information
                    </CustomerFieldsLayoutHeader>
                    <EmploymentFields employmentType="previousEmployment" />
                </ExpandedSectionCard>
            )}
        </CustomerFieldsAccordionContainer>
    );
};
